import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";
import { endpoint } from "./config";
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();

const adminSecret = process.env.REACT_APP_HASURA_ADMIN_SECRET;
if (!adminSecret) {
  throw new Error("REACT_APP_HASURA_ADMIN_SECRET is not set");
}

const client = new ApolloClient({
  uri: ({operationName}) => `${endpoint}?query=${operationName}`,
  cache: new InMemoryCache(),
  headers: {
    "x-hasura-admin-secret": adminSecret,
  },
});

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
        </QueryClientProvider>
      </Provider>
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
